module.exports = __webpack_public_path__ + "static/media/o3.ae41dd86.jpg";